import React from "react";
import { EarlyBirdCampaign } from "../../organisms/campaign/EarlyBirdCampaign";
import { useEarlyBirdCampaign } from "./hook";

export const Campaign: React.FC = () => {
  const { campaign, handleRegularOrderClick, handleEarlyBirdClick } =
    useEarlyBirdCampaign();
  return (
    <EarlyBirdCampaign
      campaign={campaign}
      handleRegularOrderClick={handleRegularOrderClick}
      handleEarlyBirdClick={handleEarlyBirdClick}
    />
  );
};
